import Icon from 'snippets/icon/icon'

function CustomModalDialog({ header, content, footer, id, type = 'modal', classClose = 'w-8 h-8 p-2', classMain = '', classContent = '', classHeader = '', className = '', isCartClear = false }) {
  return (
    <modal-dialog data-target={id} data-type={type} data-scroll-target=".modal-dialog-inner" className={`${className}`} is-cart-clear={isCartClear}>
      <div className={`relative modal-dialog-content js-content-modal-dialog ${classMain}`}>
        <div className={`relative ${classHeader}`}>
          {header}
          <button type="button" className={`absolute w-8 h-8 p-2 top-3 right-4 md:top-4 md:right-6 js-close-modal-dialog ${classClose}`}>
            <Icon name="icon-close-outline" className="w-4 h-4 text-grey-500" />
          </button>
        </div>
        <div className={`modal-dialog-inner ${classContent}`}>{content}</div>
        {footer}
      </div>
    </modal-dialog>
  )
}

export default CustomModalDialog
